function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}><g fill="none" fillRule="evenodd"><circle cx="12" cy="12" r="12" fill="#D7DBE9" /><path fill="#FFF" fillRule="nonzero" stroke="#FFF" strokeWidth=".5" d="M9.667 15.233l8.005-8.005a.778.778 0 0 1 1.1 1.1l-8.555 8.555a.778.778 0 0 1-1.1 0l-3.89-3.889a.778.778 0 0 1 1.1-1.1l3.34 3.34z" /></g></svg>;
});